import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "font-weight-bold" }, "기관 정보", -1)
const _hoisted_3 = { class: "d-flex flex-wrap gap-2 mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-3" }, "서비스 관리", -1)
const _hoisted_5 = { class: "d-flex align-center mb-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "급여 서비스", -1)
const _hoisted_7 = { class: "d-flex align-center mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "재무 서비스", -1)

import { useStore } from 'vuex';
import axios from "axios";
import { ref, onMounted, computed, onUnmounted } from "vue";
import { } from "@mdi/js";
import AdminCompSignImg from "../../../components/admin/basic-info/AdminCompSignImg.vue";
import AdminCompBasicEdit from "../../../components/admin/basic-info/AdminCompBasicEdit.vue";
import '@/assets/styles/comp-basic-info.scss';

interface SisulInfo {
  sisul_code: string;
  sisul_name: string;
  sisul_biz_num: string;
  sisul_wage_in: string;
  sisul_wage_out: string | null;
  sisul_fna_in: string;
  sisul_fna_out: string | null;
  sisul_meal_in: string;
  sisul_meal_out: string | null;
  [key: string]: string | null;
}

type Service = {
  type: string;
  in: string;
  out: string | null;
  color: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CompBasicInfo',
  setup(__props) {

const store = useStore();
const id = ref<string>("");
const SsInfo = ref<SisulInfo>({
  sisul_code: "",
  sisul_name: "",
  sisul_biz_num: "",
  sisul_wage_in: "",
  sisul_wage_out: null,
  sisul_fna_in: "",
  sisul_fna_out: null,
  sisul_meal_in: "",
  sisul_meal_out: null
});
const services = ref<Service[]>([]);

const sortedServices = computed(() => {
  return services.value
    .filter((service) => service.in && !service.out)
    .sort((a, b) => new Date(a.in).getTime() - new Date(b.in).getTime());
});

const dialog = ref(false);
const loading = ref(false);
const imageMiribogi = ref();
const imageFile = ref();
const ext = ref();
const imageType = ref();
const imageUrl = ref();
const imgName = ref();

// 서비스 체크박스 관련 변수들
const wageServiceEnabled = ref(false);
const fnaServiceEnabled = ref(false);

// 서비스 정보 업데이트 함수
const updateServiceInfo = async () => {
  loading.value = true;
  try {
    const form = {
      sisul_id: SsInfo.value.sisul_code,
      sisul_wage_in: wageServiceEnabled.value ? SsInfo.value.sisul_wage_in : null,
      sisul_wage_out: wageServiceEnabled.value ? SsInfo.value.sisul_wage_out : null,
      sisul_fna_in: fnaServiceEnabled.value ? SsInfo.value.sisul_fna_in : null,
      sisul_fna_out: fnaServiceEnabled.value ? SsInfo.value.sisul_fna_out : null,
    };

    const response = await axios.put(`/api/updateSsInfo`, { form });
    
    if (response.data.success) {
      store.commit('showSnackbar', {
        text: "서비스 정보가 성공적으로 업데이트되었습니다.",
        color: "success"
      });
      
      // 서비스 정보 다시 로드
      await readSsId();
    } else {
      store.commit('showSnackbar', {
        text: "서비스 정보 업데이트에 실패했습니다.",
        color: "error"
      });
    }
  } catch (error) {
    console.error('서비스 정보 업데이트 중 오류:', error);
    store.commit('showSnackbar', {
      text: "서비스 정보 업데이트 중 오류가 발생했습니다.",
      color: "error"
    });
  } finally {
    loading.value = false;
  }
};
const handleFileUpload = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files.length > 0) {
    const file = target.files[0];
    ext.value = file.name.split(".").pop();
    const reader = new FileReader();
    reader.onload = () => {
      imageMiribogi.value = reader.result;
    };
    reader.readAsDataURL(file);
    imageFile.value = file;
  }
};
const fetchImage = async () => {
  imageUrl.value = await getSisulMainImg();
};
const getSisulMainImg = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/api/getSisulMainImg/${imgName.value}`, {
      responseType: "blob",
    });
    if (response.data) {
      //이미지타입 추출
      imageType.value = response.data.type.split("/")[1];
      if (imageType.value === "jpeg") {
        imageType.value = "jpg";
      }
      const imageBlob = response.data;
      const imageObjectURL = URL.createObjectURL(imageBlob);
      return imageObjectURL; // 가져온 이미지 URL을 반환
    }
  } catch (error) {
    const imageObjectURL = "nothing";
    return imageObjectURL;
  } finally {
    loading.value = false;
  }
};

const sendSisulMainImg = async () => {
  if (!imageFile.value) {
    alert("이미지를 선택하세요.");
    return;
  }
  const allowedTypes = ["image/jpeg", "image/png"];
  if (!allowedTypes.includes(imageFile.value.type)) {
    alert("JPG 또는 PNG 파일만 업로드 가능합니다.");
    loading.value = false;
    return;
  }
  loading.value = true;

  try {
    if (imageUrl.value !== "nothing") {
      await deleteSilsulMainImg();
    }
    const formData = new FormData();
    formData.append("image", imageFile.value);
    const response = await axios.post(
      `/api/sendSisulMainImg/${imgName.value}/${ext.value}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response && response.data.success) {
      await fetchImage();
      dialog.value = false;
    } else {
      console.error("이미지 업로드 실패", response.data);
    }
  } catch (error) {
    console.error("이미지 업로드 중 에러 발생", error);
  } finally {
    loading.value = false;
  }
};
const deleteSilsulMainImg = async () => {
  try {
    const response = await axios.post(`/api/deleteSilsulMainImg/${imgName.value}`);
    if (!response) {
      alert("기존 파일 삭제 에러 발생.");
      return;
    }
  } catch (error) {
    console.error("이미지 업로드 중 에러 발생", error);
  }
};

const readSsId = async () => {
  try {
    const response = await axios.get(`/api/readSsId/${id.value}`);
    const responseData = response.data;
    if (responseData) {
      SsInfo.value = responseData;
      services.value = [
        {
          type: "노무관리",
          in: SsInfo.value.sisul_wage_in,
          out: SsInfo.value.sisul_wage_out,
          color: "blue-darken-2",
        },
        {
          type: "재무회계",
          in: SsInfo.value.sisul_fna_in,
          out: SsInfo.value.sisul_fna_out,
          color: "purple-darken-2",
        },
        {
          type: "위탁급식",
          in: SsInfo.value.sisul_meal_in,
          out: SsInfo.value.sisul_meal_out,
          color: "orange-darken-2",
        },
      ];
      imgName.value = SsInfo.value.sisul_code + "img";

      // 서비스 체크박스 상태 초기화
      wageServiceEnabled.value = !!(SsInfo.value.sisul_wage_in && !SsInfo.value.sisul_wage_out);
      fnaServiceEnabled.value = !!(SsInfo.value.sisul_fna_in && !SsInfo.value.sisul_fna_out);

      store.commit("setSsInfoBox", SsInfo.value);
      return responseData;
    } else {
      console.error("에러가 발생했습니다.");
    }
  } catch (error) {
    console.error("errorMsg:", error);
  }
};
onMounted(async () => {
  id.value = store.state.AdminSisulId;
  await readSsId();
  await fetchImage();
});
onUnmounted(() => {
  sessionStorage.removeItem("SsInfoBox");
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "rounded-lg" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center pa-4" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_icon, {
                  color: "primary",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-office-building")
                  ]),
                  _: 1
                }),
                _hoisted_2
              ]),
              _createVNode(_component_v_spacer),
              _createVNode(AdminCompBasicEdit, {
                onSuccess: _cache[0] || (_cache[0] = ($event: any) => (readSsId()))
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "hover-card-motion mb-4 text-center pb-3",
                        elevation: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode("기관 대표사진")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_img, {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (dialog.value = true)),
                            src: imageUrl.value,
                            height: "auto",
                            "max-height": "400",
                            contain: "",
                            class: "cursor-pointer"
                          }, {
                            placeholder: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                class: "fill-height ma-0",
                                align: "center",
                                justify: "center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_progress_circular, {
                                    indeterminate: "",
                                    color: "primary"
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["src"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card, {
                        class: "hover-card-motion",
                        elevation: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode("계약서 인감")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, { class: "text-center" }, {
                            default: _withCtx(() => [
                              _createVNode(AdminCompSignImg)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "hover-card-motion mb-4",
                        elevation: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "primary",
                                class: "mr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-information-outline")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" 기본 정보 ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item, null, {
                                            prepend: _withCtx(() => [
                                              _createVNode(_component_v_icon, { color: "primary" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-office-building-outline")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("기관명")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(SsInfo.value.sisul_name), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item, null, {
                                            prepend: _withCtx(() => [
                                              _createVNode(_component_v_icon, { color: "primary" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-identifier")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("장기요양기관기호")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(SsInfo.value.sisul_code), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item, null, {
                                            prepend: _withCtx(() => [
                                              _createVNode(_component_v_icon, { color: "primary" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-card-account-details-outline")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("사업자등록번호")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(SsInfo.value.sisul_biz_num), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item, null, {
                                            prepend: _withCtx(() => [
                                              _createVNode(_component_v_icon, { color: "primary" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-map-marker-outline")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("기관 주소")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(SsInfo.value.sisul_addr), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item, null, {
                                            prepend: _withCtx(() => [
                                              _createVNode(_component_v_icon, { color: "primary" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-phone-outline")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("기관 전화번호")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(SsInfo.value.sisul_tell), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card, {
                        class: "hover-card-motion mb-4",
                        elevation: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "primary",
                                class: "mr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-account-tie-outline")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" 대표자 정보 ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item, null, {
                                            prepend: _withCtx(() => [
                                              _createVNode(_component_v_icon, { color: "primary" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-account-outline")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("대표자 성명")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(SsInfo.value.sisul_boss_name), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item, null, {
                                            prepend: _withCtx(() => [
                                              _createVNode(_component_v_icon, { color: "primary" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-cellphone")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("대표자 번호")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(SsInfo.value.sisul_boss_phone), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item, null, {
                                            prepend: _withCtx(() => [
                                              _createVNode(_component_v_icon, { color: "primary" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-email-outline")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("대표자 이메일")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(SsInfo.value.sisul_boss_email), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item, null, {
                                            prepend: _withCtx(() => [
                                              _createVNode(_component_v_icon, { color: "primary" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-bank-outline")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("은행 정보")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(SsInfo.value.sisul_bank) + " / " + _toDisplayString(SsInfo.value.sisul_bank_num), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item, null, {
                                            prepend: _withCtx(() => [
                                              _createVNode(_component_v_icon, { color: "primary" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-account-check-outline")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "font-weight-bold" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("예금주")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(SsInfo.value.sisul_bank_owner), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card, {
                        class: "hover-card-motion",
                        elevation: "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "primary",
                                class: "mr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-cog-outline")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" 서비스 정보 ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedServices.value, (service, index) => {
                                  return (_openBlock(), _createBlock(_component_v_chip, {
                                    key: index,
                                    color: service.color,
                                    size: "large",
                                    class: "ma-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        start: "",
                                        color: service.color
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-check-circle")
                                        ]),
                                        _: 2
                                      }, 1032, ["color"]),
                                      _createTextVNode(" " + _toDisplayString(service.type), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["color"]))
                                }), 128))
                              ]),
                              _createVNode(_component_v_divider, { class: "mb-4" }),
                              _hoisted_4,
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card, {
                                        variant: "outlined",
                                        class: "pa-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_5, [
                                            _createVNode(_component_v_checkbox, {
                                              modelValue: wageServiceEnabled.value,
                                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((wageServiceEnabled).value = $event)),
                                              color: "blue-darken-2",
                                              "hide-details": "",
                                              class: "me-2"
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_v_icon, {
                                              color: "blue-darken-2",
                                              class: "me-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("mdi-cash-multiple")
                                              ]),
                                              _: 1
                                            }),
                                            _hoisted_6
                                          ]),
                                          (wageServiceEnabled.value)
                                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    cols: "12",
                                                    sm: "6"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_text_field, {
                                                        modelValue: SsInfo.value.sisul_wage_in,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((SsInfo.value.sisul_wage_in) = $event)),
                                                        label: "서비스 시작일",
                                                        type: "date",
                                                        variant: "outlined",
                                                        density: "compact",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "12",
                                                    sm: "6"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_text_field, {
                                                        modelValue: SsInfo.value.sisul_wage_out,
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((SsInfo.value.sisul_wage_out) = $event)),
                                                        label: "서비스 종료일",
                                                        type: "date",
                                                        variant: "outlined",
                                                        density: "compact",
                                                        "hide-details": "",
                                                        clearable: ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card, {
                                        variant: "outlined",
                                        class: "pa-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_7, [
                                            _createVNode(_component_v_checkbox, {
                                              modelValue: fnaServiceEnabled.value,
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((fnaServiceEnabled).value = $event)),
                                              color: "purple-darken-2",
                                              "hide-details": "",
                                              class: "me-2"
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_v_icon, {
                                              color: "purple-darken-2",
                                              class: "me-2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("mdi-calculator")
                                              ]),
                                              _: 1
                                            }),
                                            _hoisted_8
                                          ]),
                                          (fnaServiceEnabled.value)
                                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    cols: "12",
                                                    sm: "6"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_text_field, {
                                                        modelValue: SsInfo.value.sisul_fna_in,
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((SsInfo.value.sisul_fna_in) = $event)),
                                                        label: "서비스 시작일",
                                                        type: "date",
                                                        variant: "outlined",
                                                        density: "compact",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "12",
                                                    sm: "6"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_text_field, {
                                                        modelValue: SsInfo.value.sisul_fna_out,
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((SsInfo.value.sisul_fna_out) = $event)),
                                                        label: "서비스 종료일",
                                                        type: "date",
                                                        variant: "outlined",
                                                        density: "compact",
                                                        "hide-details": "",
                                                        clearable: ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { class: "mt-4" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "text-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        color: "primary",
                                        size: "large",
                                        onClick: updateServiceInfo,
                                        loading: loading.value,
                                        "prepend-icon": "mdi-content-save"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" 서비스 정보 저장 ")
                                        ]),
                                        _: 1
                                      }, 8, ["loading"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: dialog.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialog).value = $event)),
        "max-width": "700",
        class: "fontNotoSans400"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "bg-primary text-white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    start: "",
                    color: "white",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-image-edit")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" 기관 대표사진 변경 ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "pa-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_alert, {
                    type: "warning",
                    variant: "tonal",
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 이미지 변경 시 기존 이미지는 삭제됩니다. ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_file_input, {
                    accept: "image/*",
                    label: "이미지 파일 선택",
                    "prepend-icon": "mdi-camera",
                    onChange: handleFileUpload,
                    class: "mb-4"
                  }),
                  _createVNode(_component_v_img, {
                    src: imageMiribogi.value || imageUrl.value,
                    "max-height": "400",
                    contain: "",
                    class: "rounded-lg"
                  }, null, 8, ["src"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "flat",
                    onClick: sendSisulMainImg,
                    loading: loading.value,
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 업로드 ")
                    ]),
                    _: 1
                  }, 8, ["loading"]),
                  _createVNode(_component_v_btn, {
                    color: "grey-darken-1",
                    variant: "outlined",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (dialog.value = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 닫기 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})